import React, {Component, PropTypes} from 'react'
import {Table, Icon, Collapse} from 'antd'
const Panel = Collapse.Panel

class Detail extends Component {
	render () {
    const { data = {} } = this.props
    const { applyTable_summary, applyTable_atmosphere, applyTable_planning, applyTable_suggest } = data
		return (
      <div className="applyTable-w">
        <Collapse defaultActiveKey={[]}>
          <Panel header="转正申请表：" key="1">
            <div className="wrap">
              <div className="label-c">
                <div className='title'>1、请谈谈你试用期内对工作的小结：</div>
                  <ul className='sub'>
                    <li>试用期内你认为自身较为突出业绩或表现是？</li>
                    <li>目前工作与预期是否一致？</li>
                    <li>目前的工作状态和岗位的胜任情况如何？</li>
                  </ul>
              </div>
              <div className="val-c">{applyTable_summary}</div>
            </div>

            <div className="wrap">
              <div className="label-c">
                <div className='title'>2、在试用期内，你认为团队和公司的氛围如何？你与部门同事或其他部门同事的沟通是否顺畅？</div>
              </div>
              <div className="val-c">{applyTable_atmosphere}</div>
            </div>
            
            <div className="wrap">
              <div className="label-c">
                <div className='title'>3、转正后，你接下来的工作目标和个人发展计划是？</div>
              </div>
              <div className="val-c">{applyTable_planning}</div>
            </div>

            <div className="wrap">
              <div className="label-c">
                <div className='title'>4、对公司或团队有什么建议或者意见？</div>
              </div>
              <div className="val-c">{applyTable_suggest}</div>
            </div>

          </Panel>
        </Collapse>
      </div>
		)
	}
}


export default Detail


// WEBPACK FOOTER //
// ./src/components/workflow/assigneeDetail/regular/applyTable.js